import React from 'react'

import { Icon } from '@components/UI'

const Redo = ({ onClick }) => {
  return (
    <div className='control-container dark'>
      <button onClick={onClick}>
        <Icon name='redo' />
      </button>
    </div>
  )
}

export default Redo
